(function ($) {
  $("document").ready(setup);

  function setup() {
    var map;

    $(".submit-search-agency").click(findAgency);
    $(".icon-close").click(closeDetailAgency);

    if ($("#map-agency").length) {
      var centerCoords = {};
      var initZoom = 0;
      var zoomLimits = {min: 5, max: 16};
      var markers = {};
      var lang = drupalSettings.path.currentLanguage;
      if (window.matchMedia("(max-width:760px)").matches) {
        // Center France
        centerCoords = lang === 'it' ? {lat: 41.9208871, lng: 12.2124584} : ( lang === 'es' ? {lat: 40.4381311, lng: -3.8196195} : {lat: 46.603354, lng: 1.8883335} );
        initZoom = 3;
      } else if ($(".blockagency").hasClass("block-map")) {
        centerCoords = lang === 'it' ? {lat: 41.9208871, lng: 12.2124584} : ( lang === 'es' ? {lat: 40.4381311, lng: -3.8196195} : {lat: 46.603354, lng: 1.8883335} );
        initZoom = 6;
      } else {
        centerCoords = lang === 'it' ? {lat: 41.9208871, lng: 12.2124584} : ( lang === 'es' ? {lat: 40.4381311, lng: -3.8196195} : {lat: 46.5, lng: -2} );
        initZoom = 6;
      }

      // Initialisation de la carte
      var map = L.map('map-agency', {
        center: centerCoords,
        zoom: initZoom,
        minZoom: zoomLimits.min,
        maxZoom: zoomLimits.max,
        dragging: !L.Browser.mobile,
        scrollWheelZoom: false,
        scrollWheelPan: true,
        gestureHandling: true
      });
      // Design de la carte
      L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {attribution: "&copy; Akena"}).addTo(map);
      L.Icon.extend({options: {customId: ""}});
      // Zoom
      if ($(".blockagency").hasClass("block-map")) {
        L.control.zoom({position: "topright"}).addTo(map);
      }

      var markersCluster = new L.markerClusterGroup({
        polygonOptions: {
          weight: 0.5,
          opacity: 0,
          fillOpacity: 0
        }
      });

      if (navigator.geolocation) {
        generateAgencies();
        navigator.geolocation.getCurrentPosition(geolocalisation);
      } else {
        generateAgencies();
      }

      function geolocalisation(position) {
        if (position) {
          $('.find-agency').attr('data-lat', position.coords.latitude);
          $('.find-agency').attr('data-long', position.coords.longitude);

          markersCluster.clearLayers();
          map.removeLayer(markersCluster);

          $.ajax({
            type: "GET",
            url: "/ajax/find_agency_by_lat_and_lon",
            data: {
              lat: position.coords.latitude,
              lon: position.coords.longitude,
              lang: drupalSettings.path.currentLanguage,
            },
            async: true,
            dataType: "json"
          }).done(function (data) {
            var markers = {};
            var agencies = data["agencies"];
            var lang = drupalSettings.path.currentLanguage;
            if (agencies === undefined || agencies === null) {
              $(".search-zipcode-locator").removeClass("active");
              $('.error').remove();
              if (lang === "it"){
                $(".form-search-zipcode").append(
                  "<div class='error'>Nessuna agenzia vicino a te</div>"
                );
              }else if (lang === "es"){
                $(".form-search-zipcode").append(
                  "<div class='error'>No hay agencia cerca de usted</div>"
                );
              }else{
                $(".form-search-zipcode").append(
                  "<div class='error'>Aucune agence proche de chez vous</div>"
                );
              }
            } else {
              var countAgencies = agencies.length;
              var zipcodeLatLong = data["geoCodeZipCode"];

              map.setView([zipcodeLatLong[0], zipcodeLatLong[1]], 10);

              generateMarkers(agencies);

              function generateMarkers(arr) {
                var id = 0;
                arr.forEach(function (element) {
                  var type = element.type;
                  if (type == 53) {
                    classType = "cluster-crafts";
                  } else if (type == 52) {
                    classType = "cluster-resellers";
                  } else {
                    classType = "cluster-agency";
                  }

                  var myDefaultMarker = L.divIcon({
                    customId: "",
                    className: classType,
                    iconSize: [35, 47],
                    iconAnchor: [15, 47],
                    popupAnchor: [0, -45]
                  });

                  element.id = id;
                  var idString = id.toString();

                  L.marker([element.lat, element.long], {
                    icon: myDefaultMarker,
                    customId: idString
                  })
                    .addTo(map)
                    .on("click", markerClick);

                  markers[id] = element;
                  id += 1;
                });
                $(".block-details-agency").removeClass("active");
                $(".search-zipcode-locator").addClass("active");
                $(".count-locator").html(countAgencies);

                var text = "";
                var y = "1";
                for (var i = 0; i < data["agencies"].length; i++) {
                  text +=
                    "<li class='list-locator' id='list-locator-" +
                    y +
                    "' data-id=" +
                    i +
                    " data-nid=" +
                    data["agencies"][i]["nid"] +
                    " data-lat=" +
                    data["agencies"][i]["lat"] +
                    " data-lon=" +
                    data["agencies"][i]["long"] +
                    " data-type=" +
                    data["agencies"][i]["type"] +
                    "><span class='name-locator'>" +
                    y +
                    ". " +
                    data["agencies"][i]["nom"] +
                    "</span><span class='kilometer'>" +
                    data["agencies"][i]["distance"].toFixed(2) +
                    "km</span></li>";
                  y++;
                }
                $(".zone-locator").html(text);

                locatorClick();
              }

              function markerClick(e) {
                $(".block-details-agency").removeClass("active");
                $(".block-details-agency").addClass("active");
                var customId = this.options.customId;

                var coord = e.latlng;
                var lat = coord.lat;
                var lng = coord.lng;
                map.setView([lat, lng], 13);

                $(".title-popup").html(markers[customId].nom);

                var adresse = markers[customId].adresse;
                if (adresse) {
                  adresse = adresse.replace(/\n/g, "<br>");
                }
                $(".address-popup").html(adresse);
                $(".tel-popup").html('<a href="tel:+' + markers[customId].telephone + '">' + markers[customId].telephone + '</span>');
                $(".url-popup").attr("href", markers[customId].url);
              }
            }
          });

        } else {
          generateAgencies();
        }
      }

      function generateAgencies() {
        /************************************
         * Obtenir tous les agences
         */
        $.ajax({
          url: "/ajax/find_all_agency",
          type: "POST",
          data: drupalSettings.path.currentLanguage
        }).then(function (data) {
          var agencies = data["agencies"];

          var id = 0;
          agencies.forEach(function (element) {
            var type = element.type;

            if (type == 53) {
              classType = "cluster-crafts";
            } else if (type == 52) {
              classType = "cluster-resellers";
            } else {
              classType = "cluster-agency";
            }

            var myDefaultMarker = L.divIcon({
              customId: "",
              className: classType,
              iconSize: [35, 47],
              iconAnchor: [15, 47],
              popupAnchor: [0, -45]
            });

            var latLng = new L.LatLng(element.lat, element.long);

            element.id = id;
            var idString = id.toString();

            var marker = L.marker(latLng, {icon: myDefaultMarker, customId: idString}).on("click", markerClick);
            markers[id] = element;
            id += 1;
            markersCluster.addLayer(marker);
          });
        });
        map.addLayer(markersCluster);
      }

      /************************************
       * Ouverture de l'affichage avec les données d'une agence sélectionnée
       * @param e
       */
      function markerClick(e) {
        $(".block-details-agency").removeClass("active");
        $(".block-details-agency").addClass("active");
        var customId = this.options.customId;

        var coord = e.latlng;
        var lat = coord.lat;
        var lng = coord.lng;
        map.setView([lat, lng], 13);

        $(".title-popup").html(markers[customId].nom);
        var adresse = markers[customId].adresse;
        if (adresse) {
          adresse = adresse.replace(/\n/g, "<br>");
        }
        $(".address-popup").html(adresse);
        $(".tel-popup").html('<a href="tel:+' + markers[customId].telephone + '">' + markers[customId].telephone + '</span>');
        $(".url-popup").attr("href", markers[customId].url);

        if (window.matchMedia("(max-width:760px)").matches) {
          $("html, body").animate(
            {scrollTop: $(".block-details-agency").offset().top},
            500
          );
        }
      }

      /**
       * Trouve les agences les plus proches avec le code postal
       * @param e
       */
      function findAgency(e) {
        e.preventDefault();
        var lang = drupalSettings.path.currentLanguage;

        $("div.error").remove();
        var zipcode = $("#cp-code").val();
        var patternForZipCode = RegExp("^[0-9]{5}$");
        var resultZipcode = patternForZipCode.test(zipcode);

        if (!resultZipcode) {
          if (lang === "it"){
            $(this)
              .parent()
              .append(
                "<div class='error'>Si prega di inserire un codice postale valido.</div>"
              );
          }else if (lang === "es"){
            $(this)
              .parent()
              .append(
                "<div class='error'>Por favor, introduzca un código postal válido.</div>"
              );
          }else{
            $(this)
              .parent()
              .append(
                "<div class='error'>Veuillez renseigner un code postal valide.</div>"
              );
          }

        } else {
          markersCluster.clearLayers();
          map.removeLayer(markersCluster);
          $(".leaflet-marker-icon").remove();
          $(".leaflet-popup").remove();
          $.ajax({
            type: "GET",
            url: "ajax/find_agency",
            data: {
              zipcode: zipcode,
              lang: drupalSettings.path.currentLanguage,
            },
            async: true,
            dataType: "json"
          }).done(function (data) {
            var markers = {};
            var agencies = data["agencies"];

            if (agencies === undefined || agencies === null) {
              $(".search-zipcode-locator").removeClass("active");
              $('.error').remove();
              if (lang === "it"){
                $(".form-search-zipcode").append(
                  "<div class='error'>Nessuna agenzia vicino a te</div>"
                );
              }else if (lang === "es"){
                $(".form-search-zipcode").append(
                  "<div class='error'>No hay agencia cerca de usted</div>"
                );
              }else{
                $(".form-search-zipcode").append(
                  "<div class='error'>Aucune agence proche de chez vous</div>"
                );
              }
            } else {
              var countAgencies = agencies.length;
              var zipcodeLatLong = data["geoCodeZipCode"];

              map.setView([zipcodeLatLong[0], zipcodeLatLong[1]], 10);

              generateMarkers(agencies);

              function generateMarkers(agencies) {
                var id = 0;
                agencies.forEach(function (agence) {
                  var type = agence.type;
                  if (type == 53) {
                    classType = "cluster-crafts";
                  } else if (type == 52) {
                    classType = "cluster-resellers";
                  } else {
                    classType = "cluster-agency";
                  }

                  var myDefaultMarker = L.divIcon({
                    customId: "",
                    className: classType,
                    iconSize: [35, 47],
                    iconAnchor: [15, 47],
                    popupAnchor: [0, -45]
                  });

                  agence.id = id;
                  var idString = id.toString();

                  var marker = L.marker([agence.lat, agence.long], {
                    icon: myDefaultMarker,
                    customId: idString
                  }).addTo(map).on("click", markerClick);

                  markers[id] = agence;
                  id += 1;
                  markersCluster.addLayer(marker);

                });

                map.addLayer(markersCluster);

                $(".block-details-agency").removeClass("active");
                $(".search-zipcode-locator").addClass("active");
                $(".count-locator").html(countAgencies);

                var text = "";
                var y = "1";
                for (var i = 0; i < data["agencies"].length; i++) {
                  text +=
                    "<li class='list-locator' id='list-locator-" +
                    y +
                    "' data-id=" +
                    i +
                    " data-nid=" +
                    data["agencies"][i]["nid"] +
                    " data-lat=" +
                    data["agencies"][i]["lat"] +
                    " data-lon=" +
                    data["agencies"][i]["long"] +
                    " data-type=" +
                    data["agencies"][i]["type"] +
                    "><span class='name-locator'>" +
                    y +
                    ". " +
                    data["agencies"][i]["nom"] +
                    "</span><span class='kilometer'>" +
                    data["agencies"][i]["distance"].toFixed(2) +
                    "km</span></li>";
                  y++;
                }
                $(".zone-locator").html(text);

                locatorClick();
              }

              function markerClick(e) {
                $(".block-details-agency").removeClass("active");
                $(".block-details-agency").addClass("active");
                var customId = this.options.customId;

                var coord = e.latlng;
                var lat = coord.lat;
                var lng = coord.lng;
                map.setView([lat, lng], 13);

                $(".title-popup").html(markers[customId].nom);

                var adresse = markers[customId].adresse;
                if (adresse) {
                  adresse = adresse.replace(/\n/g, "<br>");
                }
                $(".address-popup").html(adresse);
                $(".tel-popup").html('<a href="tel:+' + markers[customId].telephone + '">' + markers[customId].telephone + '</span>');
                $(".url-popup").attr("href", markers[customId].url);
              }
            }
          });
        }
      }

      /**
       * Obtenir le detail d'une agence quand l'utilisateur clique sur les différents choix du Store Locator en fonction du code postal
       */
      function locatorClick() {
        $(".find-agency li").on("click", function (e) {
          e.preventDefault();
          $(".block-details-agency").removeClass("active");
          $(".find-agency li").removeClass("active");
          $(this).addClass("active");

          var id = $(this).attr("data-id");
          var lat = $(this).attr("data-lat");
          var long = $(this).attr("data-lon");
          var nid = $(this).attr("data-nid");
          var type = $(this).attr("data-type");

          if (type == 53) {
            classType = "cluster-crafts";
          } else if (type == 52) {
            classType = "cluster-resellers";
          } else {
            classType = "cluster-agency";
          }
          var myDefaultMarker = L.divIcon({
            customId: "",
            className: classType,
            iconSize: [35, 47],
            iconAnchor: [15, 47],
            popupAnchor: [0, -45]
          });

          idString = nid;
          map.setView([lat, long], 13);
          L.marker([lat, long], {icon: myDefaultMarker, customId: idString})
            .addTo(map)
            .on("click", markerClick);

          $.ajax({
            type: "GET",
            url: "/ajax/find_agency_by_id",
            data: {
              nid: nid,
              lang: drupalSettings.path.currentLanguage
            },
            async: true,
            dataType: "json"
          }).done(function (data) {
            var agencies = data["agencies"];
            $(".block-details-agency").removeClass("active");
            $(".block-details-agency").addClass("active");

            $(".title-popup").html(agencies[0].nom);
            var adresse = agencies[0].adresse;
            if (adresse) {
              adresse = adresse.replace(/\n/g, "<br>");
            }
            $(".address-popup").html(adresse);
            $(".tel-popup").html('<a href="tel:+' + agencies[0].telephone + '">' + agencies[0].telephone + '</span>');
            $(".url-popup").attr("href", agencies[0].url);

            if (window.matchMedia("(max-width:760px)").matches) {
              if ($(".landing-page").length) {
                $("html, body").animate(
                  {scrollTop: $(".block-details-agency").height().top},
                  500
                );
              } else {
                $("html, body").animate(
                  {scrollTop: $(".block-details-agency").offset().top},
                  500
                );
              }
            }
          });

          function markerClick(e) {
            var customId = this.options.customId;

            $.ajax({
              type: "GET",
              url: "/ajax/find_agency_by_id",
              data: {
                nid: customId,
                lang: drupalSettings.path.currentLanguage
              },
              async: true,
              dataType: "json"
            }).done(function (data) {
              var agencies = data["agencies"];
              $(".block-details-agency").removeClass("active");
              $(".block-details-agency").addClass("active");
              map.setView([agencies[0].lat, agencies[0].long], 13);

              $(".title-popup").html(agencies[0].nom);

              var adresse = agencies[0].adresse;
              if (adresse) {
                adresse = adresse.replace(/\n/g, "<br>");
              }
              $(".address-popup").html(adresse);
              $(".tel-popup").html('<a href="tel:+' + agencies[0].telephone + '">' + agencies[0].telephone + '</span>');
              $(".url-popup").attr("href", agencies[0].url);
            });
          }
        });
      }
    }

    if ($("#map").length) {
      generateMapDetailsAgency();
    }
  }

  // Page d'une agence, détails des informations
  function generateMapDetailsAgency() {
    if ($("#map").length) {
      var latitude = $("#latitude")
        .html()
        .trim();
      var longitude = $("#longitude")
        .html()
        .trim();
      var type = $("#type-agence")
        .html()
        .toLowerCase().trim();
      var coordinates = [latitude, longitude];
      var zoom = 8;
      setup_map(coordinates, zoom, type);
    }

    function setup_map(coordinates, zoom, type) {
      init_map(coordinates, zoom);
      place_agency(coordinates, type);
    }

    function place_agency(coordinates, type) {
      if (type == "artisan") {
        classType = "cluster-crafts";
      } else if (type == "revendeur") {
        classType = "cluster-resellers";
      } else {
        classType = "cluster-agency";
      }
      var icon = L.divIcon({
        className: classType,
        iconSize: [35, 47],
        iconAnchor: [15, 47]
      });

      L.marker(coordinates, {icon: icon}).addTo(map);
    }

    function init_map(coordinates, zoom) {
      map = L.map("map", {
        dragging: !L.Browser.mobile,
        scrollWheelZoom: false,
        scrollWheelPan: true,
        gestureHandling: true
      }).setView(coordinates, zoom);
      L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
        {attribution: "&copy; Akena"}
      ).addTo(map);
    }
  }

  function closeDetailAgency() {
    $(".block-details-agency").removeClass("active");
  }

})(jQuery);
